import { render } from "./aio-login-captcha-verify.vue?vue&type=template&id=f6e94d5c&scoped=true"
import script from "./aio-login-captcha-verify.vue?vue&type=script&lang=js"
export * from "./aio-login-captcha-verify.vue?vue&type=script&lang=js"

import "./aio-login-captcha-verify.vue?vue&type=style&index=0&id=f6e94d5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e94d5c"]])

export default __exports__